<template>
  <v-flex>
    <div class="mb-2" v-if="getSession.user.super == 1">
      <v-flex xs12 sm12 md12>
        <v-card style="box-shadow: none; background-color: #f8f8f8;">
          <v-container grid-list-md style="padding: 0 !important;">
            <v-flex xs12 sm12 md12>
              <v-layout wrap>
                <v-flex xs3 sm3 md3>
                  <label class="label-modal">Instituição</label>
                  <v-autocomplete
                    color="#f8ac4a"
                    :items="getAllInstituicoes"
                    v-model="INSTITUICAO"
                    item-text="nome"
                    item-value="id_instituicao"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3 sm3 md3>
                  <label class="label-modal">Vista tabela</label>
                  <v-autocomplete
                    color="#f8ac4a"
                    :items="[
                      { tipo: 0, nome: 'Propostas obrigatórias' },
                      { tipo: 1, nome: 'Auto propostas' },
                    ]"
                    v-model="TIPO_TABELA"
                    item-text="nome"
                    item-value="tipo"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-container>
        </v-card>
      </v-flex>

      <v-dialog persistent v-model="deleteM" max-width="390">
        <v-card>
          <v-card-title class="headline" style="margin-left: 0px !important;"
            >Remover propostas</v-card-title
          >
          <v-card-text>
            <v-flex xs12 sm12 md12>
              <label class="label-modal">Número de propostas a remover?</label>
              <v-text-field
                color="#f8ac4a"
                :hint="'max:' + max"
                persistent-hint
                mask="##"
                v-model="valor"
              ></v-text-field>
            </v-flex>
          </v-card-text>
          <v-card-actions style="margin-top: 0px !important;">
            <v-spacer></v-spacer>
            <v-btn color="#f8ac4a" flat="flat" @click.native="close"
              >Cancelar</v-btn
            >
            <v-btn color="#f8ac4a" flat="flat" @click.native="apagar"
              >Apagar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>
      <v-flex xs12 sm12 md12>
        <v-card style="box-shadow: none; background-color: #f8f8f8;">
          <v-container grid-list-md style="padding: 0 !important;">
            <v-flex xs12 sm12 md12>
              <v-layout wrap>
                <v-flex xs3 sm3 md3>
                  <label class="label-modal">Vista tabela</label>
                  <v-autocomplete
                    color="#f8ac4a"
                    :items="[
                      { tipo: 0, nome: 'Propostas obrigatórias' },
                      { tipo: 1, nome: 'Auto propostas' },
                    ]"
                    v-model="TIPO_TABELA"
                    item-text="nome"
                    item-value="tipo"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-container>
        </v-card>
      </v-flex>
    </div>
    <div>
      <v-flex xs12 md12 sm12>
        <v-layout wrap>
          <v-flex xs12 md12 sm12>
            <v-layout row>
              <v-flex xs7 md7 sm7></v-flex>
              <v-flex
                d-flex
                align-center
                justify-center
                xs1
                md1
                sm1
                v-for="(ano, an) in getAnos"
                :key="an"
              >
                {{ ano.nome }}</v-flex
              >
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            md12
            sm12
            class="mb-5"
            v-for="(objetivo, o) in getObjetivos"
            :key="o"
          >
            <v-layout
              d-flex
              align-center
              row
              style="background-color: #e1e1e1; padding: 15px 0px;"
            >
              <v-flex
                d-flex
                align-center
                justify-center
                xs7
                md7
                sm7
                class="child-1"
                ><p>
                  <b>{{ objetivo.nome }}</b> - {{ objetivo.descricao }}
                </p></v-flex
              >
              <v-flex
                d-flex
                align-center
                justify-center
                xs1
                md1
                sm1
                v-for="(ano, an1) in getAnos"
                :key="an1"
              >
              </v-flex>
            </v-layout>

            <v-flex
              xs12
              md12
              sm12
              class="mb-3"
              v-for="(medida, m) in getMedidasByObjetivo(objetivo.id_objetivo)"
              :key="m"
            >
              <v-layout
                d-flex
                align-center
                row
                style="background-color: #efefef; padding: 15px 0px;"
              >
                <v-flex
                  d-flex
                  align-center
                  justify-center
                  xs7
                  md7
                  sm7
                  class="child-2"
                  ><p>
                    <b>{{ medida.nome }}</b> - {{ medida.descricao }}
                  </p></v-flex
                >
                <v-flex
                  d-flex
                  align-center
                  justify-center
                  xs1
                  md1
                  sm1
                  v-for="(ano, an2) in getAnos"
                  :key="an2"
                >
                </v-flex>
              </v-layout>

              <v-flex
                xs12
                md12
                sm12
                v-for="(acao, a) in getAcoesByMedida(medida.id_medida)"
                :key="a"
              >
                <v-layout
                  d-flex
                  align-center
                  row
                  style="padding: 15px 0px;"
                  v-bind:style="{
                    backgroundColor: a % 2 != 0 ? '#f2f2f2' : '',
                  }"
                >
                  <v-flex
                    d-flex
                    align-center
                    justify-center
                    xs7
                    md7
                    sm7
                    class="child-3"
                    ><p>
                      <b>{{ acao.nome }}</b> - {{ acao.descricao }}
                    </p></v-flex
                  >
                  <v-flex
                    @click="
                      removeProposta(INSTITUICAO, ano.id_ano, acao.id_acao)
                    "
                    d-flex
                    align-center
                    justify-center
                    xs1
                    md1
                    sm1
                    class="ano-3"
                    v-for="(ano, an3) in getAnos"
                    :key="an3"
                  >
                    {{
                      getAcaoAno(
                        INSTITUICAO,
                        ano.id_ano,
                        acao.id_acao,
                        TIPO_TABELA
                      )
                    }}
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
    </div>
  </v-flex>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
const cName = {
  upper: "Proposta",
  lower: "a proposta!",
};

export default {
  data: () => ({
    table: "propostas",
    name: "proposta",
    INSTITUICAO: 0,
    DEFAULT_DATA: [],
    DATA: [],
    editedIndex: -1,
    valor: 0,
    max: 0,
    deleteM: false,
    array: [],
    TIPO_TABELA: 0,
    messages: {
      add: {
        success: cName.upper + " criada com sucesso!",
        error: "Ocorreu um erro ao criar " + cName.lower,
      },
      update: {
        success: cName.upper + " alterada com sucesso!",
        error: "Ocorreu um erro ao alterar " + cName.lower,
      },
      delete: {
        success: cName.upper + " eliminada com sucesso!",
        error: "Ocorreu um erro ao apagar " + cName.lower,
      },
      default: {
        sucesso: "Sucesso",
        error: "Ocorreu um erro!",
      },
    },
    defaultRules: null,
  }),

  computed: {
    ...mapGetters({
      getSession: "session/getState",
      getAll: "propostas/getAll",
      getObjetivos: "objetivos/getAll",
      getAcoes: "acoes/getAll",
      getMedidasByObjetivo: "medidas/getMedidasByObjetivo",
      getAcoesByMedida: "acoes/getAcoesByMedida",
      getAllInstituicoes: "instituicoes/getAllInstituicoes",
      getAnos: "anos/getAll",
      getAcaoAno: "propostas/getAcaoAno",
      getAcoesByInstituicao: "propostas/getAcoesByInstituicao",
    }),
  },

  watch: {
    getAll(val) {
      this.initialize();
    },
  },

  created() {
    this.initialize();

    if (this.getSession.user.super == 0)
      this.INSTITUICAO = this.getSession.user.id_instituicao;
  },

  methods: {
    async filtrar() {
      var array = [].concat(this.DATA);

      if (this.FILTRO.id_objetivo > 0) array = await this.filterObjetivo(array);
      if (this.FILTRO.id_medida > 0) array = await this.filterMedida(array);
      if (this.FILTRO.id_acao > 0) array = await this.filterAcao(array);
      if (this.FILTRO.id_instituicao > 0)
        array = await this.filterInstituicao(array);
      if (this.FILTRO.id_ano > 0) array = await this.filterAno(array);

      this.DATA = array;
    },

    limpar() {
      this.FILTRO = {
        id_objetivo: 0,
        id_medida: 0,
        id_acao: 0,
        id_ano: 0,
        id_instituicao: 0,
      };
      this.initialize();
    },

    async apagar() {
      if (this.valor == 0) {
        this.toast("error", "O valor deve ser superior a 0!");
      } else if (this.valor <= this.max) {
        var aux = await this.prepareArray(this.array.slice(0, this.valor));

        this.$store.dispatch("propostas/remove", aux).then((res) => {
          if (res) {
            this.toast("success", "Propostas removidas com sucesso!");

            this.initialize();
            this.close();
          } else {
            this.toast("error", "Ocorreu um erro ao remover as propostas.");
            this.close();
          }
        });
      } else {
        this.toast(
          "error",
          "Pode remover no máximo" + this.max + " propostas!"
        );
      }
    },

    close() {
      this.deleteM = false;

      setTimeout(() => {
        this.valor = 0;
        this.max = 0;
        this.array = [];
      }, 110);
    },

    prepareArray(array) {
      var aux = [];

      for (var a of array) {
        aux.push({
          id_proposta: a.id_proposta,
        });
      }

      return aux;
    },

    filterObjetivo(array) {
      return array.filter((el) => {
        return el.id_objetivo == this.FILTRO.id_objetivo;
      });
    },

    filterMedida(array) {
      return array.filter((el) => {
        return el.id_medida == this.FILTRO.id_medida;
      });
    },

    filterAcao(array) {
      return array.filter((el) => {
        return el.id_acao == this.FILTRO.id_acao;
      });
    },

    filterInstituicao(array) {
      return array.filter((el) => {
        return el.id_instituicao == this.FILTRO.id_instituicao;
      });
    },

    filterAno(array) {
      return array.filter((el) => {
        return el.id_ano == this.FILTRO.id_ano;
      });
    },

    async removeProposta(instituicao, ano, acao) {
      this.array = await this.getAcoesByInstituicao(
        ano,
        acao,
        instituicao
      ).filter((el) => {
        return el.auto_proposta == this.TIPO_TABELA;
      });

      this.max = this.array.length;

      if (this.max > 0) this.deleteM = true;
    },

    toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition,
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition,
        });
      }
    },

    initialize() {
      this.loading = true;
      this.DATA = this.getAll;
      this.DEFAULT_DATA = this.DATA;
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.child-1 p {
  margin: 0 !important;
  margin-left: 30px !important;
}
.child-2 p {
  margin: 0 !important;
  margin-left: 60px !important;
}

.child-3 p {
  margin: 0 !important;
  margin-left: 90px !important;
}

.child-1 {
  background-color: #e1e1e1 !important;
  font-size: 17px !important;
  display: flex !important;
  align-items: center !important;
}

.child-2 {
  background-color: #efefef !important;
  font-size: 15px !important;
  display: flex !important;
  align-items: center !important;
}

.child-3 {
  display: flex !important;
  align-items: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tables/Table_Home.vue